module.exports = __webpack_public_path__ + "static/media/cf.99c6b22d.svg";